import { useTheme } from "@emotion/react";
import { Box, Grid, Hidden, Icon, Typography } from "@mui/material";

export default function HeaderTitle({ title }) {
  const theme = useTheme();
  const styles = {
    title: {
      display: "flex",
      alignItems: "center",
      gap: 1,
      color: theme.palette.secondary.main,
      fontFamily: "Inter-Regular",
    },
    icon: {
      fontSize: "1.5rem",
      color: theme.palette.primary.main,
    },
  };

  return (
    <Box sx={styles.title} style={{ display: "flex", alignContent: "center" }}>
      <Hidden smDown>
        <Typography sx={styles.title} variant="h5">
          {title}
        </Typography>
      </Hidden>
      <Hidden mdUp>
        <Typography
          sx={styles.title}
          variant="subtitle1"
          style={{ lineHeight: 1.2 }}
        >
          {title}
        </Typography>
      </Hidden>
    </Box>
  );
}
